export default class GetAllConvocatoriasPersonal {
  #repository
  constructor(repository) {
    this.#repository = repository
  }
  async execute() {
    try {
      const result = await this.#repository.getAllConvocatoriasPersonal()
      return result
    } catch (error) {
      console.error('Error al obtener las asignaciones de convocatorias:', error)
      throw error
    }
  }
}
